import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "female_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18 9a6.002 6.002 0 0 1-5 5.917V17h3v2h-3v3h-2v-3H8v-2h3v-2.083A6.002 6.002 0 0 1 12 3a6 6 0 0 1 6 6Zm-6 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }